import {useContext, useMemo} from "react";

import type {Listing} from "../../../models/listing";
import {UserContext} from "../../contexts/UserContext";

export function useListingsTypes() {
    const {listings} = useContext(UserContext);

    return useMemo(
        () =>
            listings.reduce<{
                messagingListings: Listing[];
                proListings: Listing[];
                enabledListings: Listing[];
            }>(
                (acc, listing) => {
                    if (listing.pricingPlan === "Messaging") {
                        acc.messagingListings.push(listing);
                    }
                    if (listing.pricingPlan === "Pro") {
                        acc.proListings.push(listing);
                    }
                    if (listing.listingEnabled) {
                        acc.enabledListings.push(listing);
                    }
                    return acc;
                },
                {
                    messagingListings: [],
                    proListings: [],
                    enabledListings: []
                }
            ),
        [listings]
    );
}
